import { useFormik } from "formik";
import { useDispatch } from "react-redux";

import { Form, Input } from "components/Form";
import { usePartnerships } from "hooks/usePartnerships";
import { MobyContainer } from "./Moby.styles";
import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Loader } from "components/Loader";
import { Button } from "components/Button";

export const MobyTab = () => {
  const dispatch = useDispatch();
  const { isLoading, partnerships, connectPartnership } = usePartnerships();
  const mobyPartnership = partnerships?.moby || {};

  const formik = useFormik({
    initialValues: { code: "" },
    onSubmit: async (values, { resetForm }) => {
      try {
        const result = await connectPartnership("moby", values.code);
        if (result.success) {
          resetForm();
        }
      } catch (error) {
        dispatch(
          toast({
            type: "error",
            body: parseErrorMessage(error),
          })
        );
      }
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <MobyContainer>
      <h3>Moby Partnership</h3>
      {mobyPartnership.status === "active" ? (
        <div className="content-section">
          <p>Your Moby integration is active and connected.</p>
        </div>
      ) : (
        <div className="content-section">
          <p>
            {mobyPartnership.description ||
              "Connect your Moby account to get started."}
          </p>
          {mobyPartnership.setup_instructions && (
            <p className="setup-instructions">
              {mobyPartnership.setup_instructions}
            </p>
          )}
          <Form onSubmit={formik.handleSubmit} className="connection-form">
            <Input
              label="Authentication Code"
              placeholder="Enter your authentication code"
              required
              {...formik.getFieldProps("code")}
            />
            <Button
              type="submit"
              variant="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <Loader className="on-btn" />
              ) : (
                "Connect Moby"
              )}
            </Button>
          </Form>
        </div>
      )}
    </MobyContainer>
  );
};
